import { appAccess, appAccountMenuButtonsForFASAdmin, appRedirectForFASAdmin, appSidebarSectionsForFASAdmin, appSpecificButtonListForFASAdmin, appSpecificRoutesForFASAdmin } from './shared/helpers/app-spec-fas-admin-config';
import { QuestionDatabaseModule } from './components/question-database/question-database.module';
import { GenerateUsersModule } from './components/generate-users/generate-users.module';
import { TransactionsModule } from './components/transactions/transactions.module';
import { provideFASAdminLibApiConfig, provideFASAdminLibConfig } from 'fas-admin';
import { StudentsModule } from './components/students/students.module';
import { FASAuthModule, FASTokenInterceptor } from 'fas-auth-poc';
import { NgModule, importProvidersFrom } from '@angular/core';
import { ExamsModule } from './components/exams/exams.module';
import { RouterModule, RouterOutlet } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { OskModule } from './components/osk/osk.module';
import { API_URL } from '../api/models/api-url.token';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { routes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { OskSubscriptionsModule } from './components/osk-subscriptions/osk-subscriptions.module';
import { ToastModule } from 'primeng/toast';
import { ElearningModule } from './components/elearning/elearning.module';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { PlatformUsersModule } from './components/platform-users/platform-users.module';
import { LectureGroupsModule } from './components/lecture-groups/lecture-groups.module';
import { AnalyticsConsentBarComponent } from './shared/components/analytics-consent-bar/analytics-consent-bar.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AnalyticsConsentBarComponent,
    PlatformUsersModule,
    LectureGroupsModule,
    ElearningModule,
    QuestionDatabaseModule,
    OskModule,
    OskSubscriptionsModule,
    GenerateUsersModule,
    StudentsModule,
    TransactionsModule,
    ExamsModule,
    StatisticsComponent,
    CommonModule,
    RouterOutlet,
    BrowserModule,
    RouterModule.forRoot(routes),
    HttpClientModule,
    ToastModule
  ],
  providers: [
    provideFASAdminLibConfig({
      companyName: 'Prawko',
      accessRules: appAccess,
      specButtonList: appSpecificButtonListForFASAdmin,
      sidebarSections: appSidebarSectionsForFASAdmin,
      customRoutes: appSpecificRoutesForFASAdmin,
      redirectConfig: appRedirectForFASAdmin,
      accountMenuButtons: appAccountMenuButtonsForFASAdmin,
    }),
    provideFASAdminLibApiConfig(environment.webApiUrl),
    {
      provide: API_URL,
      useValue:  environment.webApiUrl,
    },
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      FASAuthModule.forRoot({
        apiUrl: environment.webApiUrl,
        googleClientId: environment.googleClientId,
        facebookId: environment.facebookId,
        appleClientId: environment.appleClientId,
        appleRedirectURI: environment.appleRedirectURI,
        noLoggedRedirect:'/auth',
        registrationEndpoint: '/NewPublicOsk'
      })
    ),
    { provide: HTTP_INTERCEPTORS, useClass: FASTokenInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
